
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"82","height":"81","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M41.28 48.338V12L7.629 67l33.65-18.662z","fill":"url(#paint0_linear_15015_182560)"}}),_c('path',{attrs:{"d":"M41.277 48.338V12l33.651 55-33.65-18.662z","fill":"url(#paint1_linear_15015_182560)"}}),_c('path',{attrs:{"d":"M7.629 66.999l33.65-18.662L74.93 67H7.63z","fill":"url(#paint2_linear_15015_182560)"}}),_c('defs',[_c('linearGradient',{attrs:{"id":"paint0_linear_15015_182560","x1":"41.353","y1":"12.035","x2":"-4.352","y2":"13.42","gradientUnits":"userSpaceOnUse"}},[_c('stop',{attrs:{"stop-color":"#DAF6FB"}}),_c('stop',{attrs:{"offset":".778","stop-color":"#8CDAE3"}})]),_c('linearGradient',{attrs:{"id":"paint1_linear_15015_182560","x1":"20.411","y1":"31.733","x2":"51.37","y2":"10.467","gradientUnits":"userSpaceOnUse"}},[_c('stop',{attrs:{"stop-color":"#56BFC7"}}),_c('stop',{attrs:{"offset":"1","stop-color":"#8CDAE3"}})]),_c('linearGradient',{attrs:{"id":"paint2_linear_15015_182560","x1":"41.765","y1":"73.615","x2":"39.338","y2":"48.813","gradientUnits":"userSpaceOnUse"}},[_c('stop',{attrs:{"stop-color":"#56BFC7"}}),_c('stop',{attrs:{"offset":"1","stop-color":"#29757A"}})])])])
          )
        }
      }
    